<template>
  <div>
    <v-toolbar dense color="white">
      <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form ref="form">
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p
          v-if="LalertNotificationScreenMode.isDuplicate()"
          style="margin: 5px 0 15px 0"
        >
          以下を編集してください。
        </p>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="submitItem.disasterNo"
              :items="disastersInfo"
              :rules="[rules.required]"
              label="災害名称"
              :placeholder="config.PLACEHOLDER_SELECT"
              item-text="disaster_name"
              item-value="disaster_no"
              outlined
              clearable
              @change="changeDisaster"
              :disabled="checkDeliveryCls('FU', 'CO', 'CA')"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              :value="deliveryClsName"
              label="配信区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="3" md="8" lg="6">
            <v-select
              v-model="submitItem.deliveryArea"
              :items="[...municipalities]"
              :rules="[rules.requiredMultiple]"
              label="配信先エリア"
              :placeholder="config.PLACEHOLDER_SELECT"
              multiple
              clearable
              outlined
              :disabled="checkDeliveryCls('FU', 'CO', 'CA')"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="selectAllToggle">
                  <v-list-item-action>
                    <v-icon>
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> 全て </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col>
            <v-btn
              class="mx-2 mt-3"
              @click="markPazUpz"
              color="primary"
              :disabled="checkDeliveryCls('FU', 'CO', 'CA')"
              >PAZ及びUPZ
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              class="mx-2 mt-3"
              @click="showTempleteDialog = true"
              color="primary"
              :disabled="checkDeliveryCls('CA')"
              >テンプレート選択
            </v-btn>
          </v-col>
        </v-row>

        <p style="margin: 5px 0 5px 10px">
          以下の情報を配信することはできません。<br />
          ・電話番号／メールアドレス／URL<br />
          ・環境依存文字（「①」等）やJIS第三水準以降（「﨑」等）の文字<br />
          URLを配信する場合は「関連するホームページ（URL）」へ入力してください。<br />
        </p>
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="submitItem.deliveryTitle"
              label="件名"
              :placeholder="config.PLACEHOLDER_INPUT"
              v-bind="formControlProps(128)"
              outlined
              :disabled="checkDeliveryCls('CA')"
              :rules="[rules.required]"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <!-- テンプレートダイアログ -->
        <v-dialog v-model="showTempleteDialog">
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
              <v-toolbar dense color="white">
                <v-toolbar-title>テンプレート選択</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-data-table
                :headers="templateHeaders"
                :items="templateItems"
                class="elevation-1 mt-2"
                hide-default-footer
                no-data-text="テンプレートはありません。"
                :items-per-page="-1"
              >
                <template v-slot:[`item.select`]="{ item }">
                  <v-btn
                    class="mx-2"
                    color="primary"
                    @click="selectLanguage(item)"
                  >
                    選択
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                @click="showTempleteDialog = false"
                >キャンセル</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="8">
            <v-textarea
              v-model="submitItem.lalertMessage"
              label="本文"
              :placeholder="config.PLACEHOLDER_INPUT"
              counter="2000"
              maxlength="2000"
              outlined
              :disabled="checkDeliveryCls('CA')"
              :rules="[rules.required]"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-form v-model="isDateValidation">
          <datetime-picker
            :title="'公開希望終了日時'"
            :without-now="true"
            :disabled="checkDeliveryCls('CA')"
            :datetime="submitItem.publishEndDate"
            :selectedDatetime.sync="submitItem.publishEndDate"
            :min="String(new Date())"
            :is-clear-when-init="true"
            :validation="true"
          />
        </v-form>
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="submitItem.relatedUrl"
              label="関連するホームページ（URL）"
              :placeholder="config.PLACEHOLDER_INPUT"
              v-bind="formControlProps(1000)"
              outlined
              :disabled="checkDeliveryCls('CA')"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="submitItem.correctCancelReason"
              label="訂正／取消理由"
              :placeholder="config.PLACEHOLDER_INPUT"
              v-bind="formControlProps(100)"
              outlined
              :rules="[rules.required]"
              :disabled="checkDeliveryCls('NE', 'FU')"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-row>
      <v-col>
        <v-btn
          :disabled="isDisabled('SUBMIT')"
          @click="submit()"
          class="mx-2"
          color="primary"
        >
          送信
        </v-btn>
        <v-btn
          :disabled="isDisabled('TEMPORARILY_SAVED')"
          @click="execute('1')"
          class="mx-2"
          color="primary"
        >
          一時保存
        </v-btn>
        <v-btn class="mx-2" color="primary" @click="onClickReturn">
          キャンセル
        </v-btn>
      </v-col>
    </v-row>
    <confirm-dialog ref="confirmSubmit"></confirm-dialog>
    <v-overlay :value="overlay" opacity="0.5" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import ConfirmDialog from "@/components/ConfirmDialog";
import config from "@/js/const";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { DisasterClass } from "@/js/value-objects/disaster-class";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import Disaster from "@/plugins/disaster";
import { ScreenId } from "@/js/value-objects/screen-id";
import messageUtils from "@/mixins/message-utils";
import { arrayCount } from "@/js/utils";
import DateUtils from "@/plugins/date-utils";
import { LalertNotificationScreenMode } from "@/js/value-objects/lalert-notification-screen-mode.js";

Vue.use(Disaster);
Vue.use(DateUtils);

const lalertInfoRepository = RepositoryFactory.get("lalertInfo");
const disasterStaffMstRepository = RepositoryFactory.get("disasterStaffMst");
const systemInfoRepository = RepositoryFactory.get("systemInfo");

const LALERT_MESSAGE =
  "Lアラートを送信すると、メディアや通信事業者への通知が行われます。\n本当に送信してもよろしいですか？";

const DELIVERY_STATUS_NON = "0"; //未配信
const DELIVERY_STATUS_LIVE = "1"; //配信中

export default {
  mixins: [messageUtils],
  components: {
    ConfirmDialog,
    DatetimePicker: () => import("@/components/DatetimePicker"),
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    delivery_no: String,
    delivery_cls: String
  },
  data: () => ({
    overlay: false,
    LalertNotificationScreenMode: "",
    config: config,
    screenId: "",
    screenTitle: "",
    category: "PAZ_UPZ",
    deliveryClsFlag: false, // 一覧画面で続報・訂正・取消ボタン押下有無
    disastersInfo: [
      {
        disaster_no: 0,
        disaster_name: ""
      }
    ], // 災害情報(未終結)
    lalertInfo: {}, // Lアラート情報
    systemInfos: [], // PAZ UPZ情報
    municipalities: [], // 市町村情報
    templateItems: [], // テンプレート情報
    submitItem: {
      deliveryNo: "", // 配信番号
      deliveryNoSub: "", // 配信番号枝番
      disasterNo: "", // 災害番号
      emergCls: EmergencyClass.NL, // 緊急事態区分
      deliveryCls: "NE", // 配信区分
      deliveryTitle: "", // 件名
      lalertMessage: "", // 本文／避難行動指針
      publishEndDate: "", // 希望公開終了日時
      deliveryStatus: "0", // 配信ステータス
      relatedUrl: "", // 関連するホームページ
      correctCancelReason: "", // 訂正/取消理由
      deliveryCa: "LI", // 配信種別
      disasterCls: DisasterClass.T, // 災害区分
      dests: [], // 配信エリアAPI送信用
      hash: "", // ハッシュ値
      deliveryArea: [] // 配信先エリア
    }, // サーバー側に渡す値
    isDateValidation: false, // 希望公開終了日時の入力チェック用
    rules: {
      required: value => !!value || "必須項目です。",
      requiredMultiple: value => value.length !== 0 || "必須項目です。"
    },
    showTempleteDialog: false // テンプレートダイアログ表示有無
  }),

  computed: {
    // ボタンの非活性制御（true：非活性、false：活性）
    isDisabled() {
      return function(buttonId) {
        let disabled = false;
        switch (buttonId) {
          // 送信ボタンと一時保存ボタンは同じ制御
          case "SUBMIT":
          case "TEMPORARILY_SAVED":
            if (["NE", "FU"].includes(this.submitItem.deliveryCls)) {
              // 配信区分が「新規広報」、「続報」の場合
              //「配信先エリア」、「件名」、「本文」、「希望公開終了日時」入力されたらタンが活性化される。
              // 配信区分が新規広報場合のみ災害名称のチェックをする
              if (
                this.submitItem.deliveryArea.length == 0 ||
                !this.submitItem.deliveryTitle ||
                !this.submitItem.lalertMessage ||
                !this.submitItem.publishEndDate ||
                !this.isDateValidation ||
                !this.submitItem.disasterNo
              ) {
                disabled = true;
              }
            } else if (["CO", "CA"].includes(this.submitItem.deliveryCls)) {
              // 配信区分が「訂正報」、「取消報」の場合
              //「配信先エリア」、「件名」、「本文」、「希望公開終了日時」、「訂正／取消理由」入力されたらボタンが活性化される。
              if (
                this.submitItem.deliveryArea.length == 0 ||
                !this.submitItem.deliveryTitle ||
                !this.submitItem.lalertMessage ||
                !this.submitItem.publishEndDate ||
                !this.isDateValidation ||
                !this.submitItem.correctCancelReason ||
                !this.submitItem.disasterNo
              ) {
                disabled = true;
              }
            }
            break;
          case "DUPLICATE":
            break;
          case "CANCEL":
            break;
          default:
            break;
        }
        return disabled;
      };
    },

    // 災害名称（参照用）
    disasterName() {
      const disasterItem = this.disastersInfo.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        return disasterItem.disaster_name;
      } else {
        return "";
      }
    },

    // 緊急事態区分（参照用）
    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    // 配信区分表示用
    deliveryClsName() {
      const DELIVERY_CLS_NAMELIST = [
        {
          value: "NE",
          text: "新規広報"
        },
        {
          value: "FU",
          text: "続報"
        },
        {
          value: "CO",
          text: "訂正報"
        },
        {
          value: "CA",
          text: "取消報"
        }
      ];

      return DELIVERY_CLS_NAMELIST.find(
        e => e.value == this.submitItem.deliveryCls
      )?.text;
    },

    // 桁数チェック
    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(false, counter);
      };
    },

    // select templata
    templateHeaders() {
      return [
        {
          value: "template_id",
          text: "template id",
          align: " d-none"
        },
        {
          value: "select",
          text: "",
          width: "10%"
        },
        {
          value: "phrase_name",
          text: "テンプレート名称",
          align: ""
        },
        {
          value: "emergency_class",
          text: "緊急事態区分",
          align: ""
        },
        {
          value: "title",
          text: "件名",
          align: ""
        },
        {
          value: "contents",
          text: "本文",
          align: ""
        },
        {
          value: "link_url",
          text: "関連URL",
          align: ""
        }
      ];
    },

    // 配信先エリアが全部選択されている状態の有無
    selectAllMunicip() {
      return this.submitItem.deliveryArea.length === this.municipalities.length;
    },

    // セレクトボックスの一部が選択されているかをチェック
    selectMunicip() {
      return this.submitItem.deliveryArea.length > 0 && !this.selectAllMunicip;
    },

    // セレクトボックスの「全て」アイコン
    icon() {
      if (this.selectAllMunicip) return "mdi-close-box"; // ×
      if (this.selectMunicip) return "mdi-minus-box"; // -
      return "mdi-checkbox-blank-outline"; // 空白
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // Set the ID & Screen name
      this.LalertNotificationScreenMode = LalertNotificationScreenMode.factory(
        this.$route.name
      );
      this.screenId = this.LalertNotificationScreenMode.getScreenId();
      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);

      // 一覧画面で編集・続報・訂正・取消ボタン押下時、初期化する
      this.delivery_no = this.$route.params.delivery_no; // 配信番号
      this.delivery_cls = this.$route.params.delivery_cls; // 配信区分

      // 一覧画面でパラメータで渡された値を配信番号作成
      const PARAMS = {
        delivery_no: this.delivery_no?.split("-")[0],
        delivery_no_sub: this.delivery_no?.split("-")[1]
      };

      // 市町村
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // 「編集」「コピーして編集」の場合
      // Lアラート（お知らせ）情報
      if (
        this.LalertNotificationScreenMode.isEdit() ||
        this.LalertNotificationScreenMode.isDuplicate()
      ) {
        // 編集画面で再読み込みする場合、配信番号がないため一覧画面に戻る
        if (!PARAMS.delivery_no) {
          this.$router.push("/lalert");
        }

        await lalertInfoRepository
          .list(this.screenId, PARAMS)
          .then(res => {
            this.lalertInfo = res.data.results[0];
          })
          .catch(e => {
            this.handleError(e, this.screenId, "lalert-management");
          });
      }

      // テンプレート情報
      await this.$store
        .dispatch("fixedPhrase/loadFixedPhrase", this.screenId)
        .then(() => {
          this.fixedPhrases = this.$store.state.fixedPhrase.data.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // ログインユーザ情報
      await disasterStaffMstRepository
        .ownList(this.screenId)
        .then(res => {
          this.disasterStaff = res.data.results[0];
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // システムマスタ情報（PAZ UPZ）
      await systemInfoRepository
        .list(this.screenId, this.category)
        .then(res => {
          this.systemInfos = res.data.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // 災害情報
      await this.$store
        .dispatch("disasterInfo/loadDisasterInfo", this.screenId)
        .then(() => {
          // 災害情報（未終結）
          this.disastersInfo = this.$store.state.disasterInfo.unfinished.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // DBからもらった災害情報が終結か未終結かチェック、終結の場合TRUE
      const IS_FINISHED_DISASTER = !this.disastersInfo.some(
        obj => obj.disaster_no === this.lalertInfo.disaster_no
      );

      // 編集する値をセットする（編集・コピーのみ）
      if (
        this.LalertNotificationScreenMode.isEdit() ||
        this.LalertNotificationScreenMode.isDuplicate()
      ) {
        this.submitItem.deliveryNo = PARAMS.delivery_no;
        this.submitItem.deliveryNoSub = PARAMS.delivery_no_sub;
        this.submitItem.disasterNo = this.LalertNotificationScreenMode.isDuplicate()
          ? ""
          : this.lalertInfo.disaster_no; // コピー編集の場合、災害番号を空白に設定する
        this.submitItem.emergCls = this.lalertInfo.emerg_cls;
        this.submitItem.deliveryCls = this.LalertNotificationScreenMode.isDuplicate()
          ? "NE"
          : this.lalertInfo.delivery_cls; // コピー編集の場合、配信区分を「新規」を設定する
        this.submitItem.deliveryTitle = this.lalertInfo.delivery_title;
        this.submitItem.lalertMessage = this.lalertInfo.lalert_message;
        this.submitItem.publishEndDate = this.LalertNotificationScreenMode.isDuplicate()
          ? ""
          : this.lalertInfo.publish_end_date; // コピー編集の場合、希望公開終了日時を空白をを設定する
        this.submitItem.deliveryStatus = this.LalertNotificationScreenMode.isDuplicate()
          ? "0"
          : this.lalertInfo.delivery_status; //  コピー編集の場合、配信状況を未配信に設定する
        this.submitItem.relatedUrl = this.lalertInfo.related_url;
        this.submitItem.correctCancelReason = this.LalertNotificationScreenMode.isDuplicate()
          ? ""
          : this.lalertInfo.correct_cancel_reason; // コピー編集の場合、訂正/取消理由を空白をを設定する
        this.submitItem.hash = this.lalertInfo.hash;
        if (arrayCount(this.lalertInfo.dests) > 0) {
          this.lalertInfo.dests.forEach(dest => {
            this.submitItem.deliveryArea.push(dest.municip_code);
          });
        }
        // 終結災害情報の場合、災害情報を空欄に設定する（送信ボタンの非活性化のため）
        if (
          IS_FINISHED_DISASTER ||
          this.LalertNotificationScreenMode.isDuplicate()
        ) {
          this.submitItem.disasterNo = "";
        } else {
          this.submitItem.disasterNo = this.lalertInfo.disaster_no;
        }
      }

      // 一覧画面で押下する続報・訂正・取消ボタンによって配信区分を初期化する
      if (this.delivery_cls) {
        this.submitItem.deliveryCls = this.$route.params.delivery_cls;
        this.deliveryClsFlag = true; // 一覧画面で続報・訂正・取消ボタン押下有無
      }

      // 新規登録の場合、トップ画面で設定した災害名称をテキストボックスにセット
      if (this.LalertNotificationScreenMode.isCreate()) {
        this.submitItem.disasterNo = this.$disaster.disaster_no;
      }

      // 緊急事態区分・災害区分の初期化
      const disasterItem = this.disastersInfo.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      // 緊急事態区分・災害区分の初期化
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
        this.submitItem.disasterCls = disasterItem.disaster_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
        this.submitItem.disasterCls = DisasterClass.T;
      }

      // テンプレート情報設定
      if (arrayCount(this.fixedPhrases) > 0) {
        this.fixedPhrases.forEach(fixedPhrase => {
          //Lアラート(お知らせ)のテンプレート情報を取得する
          if (fixedPhrase.delivery_ca === "LI") {
            let pushItem = {
              phrase_name: fixedPhrase.template_name,
              emergency_class: fixedPhrase.emerg_cls,
              link_url: fixedPhrase.phrases?.filter(e => e.locale === "ja")[0]
                ?.link_url
                ? "○"
                : "-", // 関連URLが存在すれば○存在しなければ―
              title: fixedPhrase.phrases.filter(e => e.locale === "ja")[0]
                .title,
              contents: fixedPhrase.phrases.filter(e => e.locale === "ja")[0]
                .phrase
            };
            this.templateItems.push(pushItem);
          }
        });
      }

      this.overlay = false;
    },

    // 送信ボタン押下時処理
    async submit() {
      let message =
        "送信先に所属市町村以外のエリアも選択されています。\n" +
        "送信してもよろしいですか?";
      if (this.isNotArea()) {
        const result = await this.$refs.confirmSubmit.open(
          message,
          "送信",
          null
        );
        if (!result) {
          return;
        }
      }
      const result = await this.$refs.confirmSubmit.open(
        LALERT_MESSAGE,
        "送信",
        null
      );
      if (!result) {
        return;
      }
      this.execute();
    },

    // 送信・一時保存処理
    // temporarilySavedが０の場合、送信
    // temporarilySavedが１の場合、一時保存
    async execute(temporarilySaved = "0") {
      this.overlay = true;
      this.submitItem.deliveryStatus =
        temporarilySaved === "1" ? DELIVERY_STATUS_NON : DELIVERY_STATUS_LIVE; // 配信ステータス判定
      if (
        //「新規登録」「コピーして編集」の場合
        // 登録処理
        this.LalertNotificationScreenMode.isDuplicate() ||
        this.LalertNotificationScreenMode.isCreate()
      ) {
        this.executeCreateApi();
      } else if (
        // 一覧画面で続報・訂正・取消ボタン押下の場合
        // 登録処理(編集画面使用)
        this.LalertNotificationScreenMode.isEdit() &&
        this.deliveryClsFlag
      ) {
        this.executeCreateApi();
      } else if (
        //「編集」の場合
        // 更新処理
        this.LalertNotificationScreenMode.isEdit()
      ) {
        this.executeUpdateApi();
      }
      this.overlay = false;
    },

    // キャンセルボタン押下時処理
    onClickReturn() {
      this.$router.push("/lalert");
    },

    // 災害名称セレクトボックス変更時
    changeDisaster(value) {
      const disasterItem = this.disastersInfo.find(
        obj => obj.disaster_no === value
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
        this.submitItem.disasterCls = disasterItem.disaster_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
        this.submitItem.disasterCls = DisasterClass.T;
      }
    },

    // 登録処理
    async executeCreateApi() {
      // API実行前処理
      // 入力情報をAPI形式に変換
      this.setDests();
      let payload = this.toCreatePayload(this.submitItem);
      this.deleteItem(payload); // 不要項目削除（1件も存在しない場合はキー自体設定しない）
      this.clearMessage();

      // 登録API呼び出し
      await lalertInfoRepository
        .create(ScreenId.SF2103, payload)
        .then(response => {
          this.handleSuccess(response, "lalert-management");
        })
        .catch(e => {
          this.handleCreateError(e);
        });
    },

    // 更新処理
    async executeUpdateApi() {
      // API実行前処理
      // 入力情報をAPI形式に変換
      this.setDests();
      let payload = this.toUpdatePayload(this.submitItem);
      this.deleteItem(payload); // 不要項目削除（1件も存在しない場合はキー自体設定しない）
      this.clearMessage();

      // 更新API呼び出し
      await lalertInfoRepository
        .update(ScreenId.SF2103, payload)
        .then(response => {
          this.handleSuccess(response, "lalert-management");
        })
        .catch(e => {
          this.handleCreateError(e);
        });
    },

    //テンプレート選択
    selectLanguage(item) {
      this.submitItem.deliveryTitle = item.title;
      this.submitItem.lalertMessage = item.contents;
      this.showTempleteDialog = false;
      return;
    },

    // 配信先エリア判定 対象外に配信先エリアを含む true
    isNotArea() {
      let isNotAreaFlg = false;
      this.submitItem.deliveryArea.forEach(area => {
        if (area !== this.disasterStaff.municip_code) {
          isNotAreaFlg = true;
        }
      });
      return isNotAreaFlg;
    },

    // 配信先エリア設定（API形式に変換）
    setDests() {
      this.submitItem.dests = [];
      this.submitItem.deliveryArea.forEach(item => {
        let mapItem = {
          municip_code: item
        };
        this.submitItem.dests.push(mapItem);
      });
    },

    // 不要項目削除（1件も存在しない場合はキー自体設定しない）
    deleteItem(payloadItem) {
      // 配信先エリアが空の場合はキー項目削除
      if (payloadItem?.dests?.length === 0) {
        this.$delete(payloadItem, "dests");
      }
    },

    //登録処理用ペイロード作成
    toCreatePayload(item) {
      let retPayload;

      switch (item.deliveryCls) {
        // 新規
        case "NE":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_title: item.deliveryTitle, // 配信タイトル
            delivery_status: item.deliveryStatus, // 配信状況
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate), // 希望公開終了日時の日付形式変更 (YYYY-MM-DD HH:mm:00)
            dests: item.dests // 配信先エリア
          };
          break;
        // 継続
        case "FU":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_no: item.deliveryNo, // 元の配信番号
            delivery_no_sub: item.deliveryNoSub, // 元の配信番号
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_status: item.deliveryStatus, // 配信状況
            delivery_title: item.deliveryTitle, // 配信タイトル
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate) // 希望公開終了日時の日付形式変更 (YYYY-MM-DD HH:mm:00)
          };
          break;
        // 訂正
        case "CO":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_no: item.deliveryNo, // 元の配信番号
            delivery_no_sub: item.deliveryNoSub, // 元の配信番号
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_status: item.deliveryStatus, // 配信状況
            delivery_title: item.deliveryTitle, // 配信タイトル
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate), // 希望公開終了日時の日付形式変更 (YYYY-MM-DD HH:mm:00)
            correct_cancel_reason: item.correctCancelReason // 訂正/取消理由
          };
          break;
        // 取消
        case "CA":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_no: item.deliveryNo, // 元の配信番号
            delivery_no_sub: item.deliveryNoSub, // 元の配信番号
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_status: item.deliveryStatus, // 配信状況
            delivery_title: item.deliveryTitle, // 配信タイトル
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate), // 希望公開終了日時の日付形式変更 (YYYY-MM-DD HH:mm:00)
            correct_cancel_reason: item.correctCancelReason // 訂正/取消理由
          };
          break;
      }
      return retPayload;
    },

    //編集処理用ペイロード作成
    toUpdatePayload(item) {
      let retPayload;

      switch (item.deliveryCls) {
        // 新規
        case "NE":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_no: item.deliveryNo, // 元の配信番号
            delivery_no_sub: item.deliveryNoSub, // 元の配信番号
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_title: item.deliveryTitle, // 配信タイトル
            delivery_status: item.deliveryStatus, // 配信状況
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate), //希望公開終了日時
            hash: item.hash, // ハッシュ値
            dests: item.dests // 配信先エリア
          };
          break;
        // 継続
        case "FU":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_no: item.deliveryNo, // 元の配信番号
            delivery_no_sub: item.deliveryNoSub, // 元の配信番号
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_status: item.deliveryStatus, // 配信状況
            delivery_title: item.deliveryTitle, // 配信タイトル
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate), //希望公開終了日時
            hash: item.hash // ハッシュ値
          };
          break;
        // 訂正
        case "CO":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_no: item.deliveryNo, // 元の配信番号
            delivery_no_sub: item.deliveryNoSub, // 元の配信番号
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_status: item.deliveryStatus, // 配信状況
            delivery_title: item.deliveryTitle, // 配信タイトル
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate), // 希望公開終了日時
            correct_cancel_reason: item.correctCancelReason, // 訂正/取消理由
            hash: item.hash // ハッシュ値
          };
          break;
        // 取消
        case "CA":
          retPayload = {
            disaster_no: item.disasterNo, // 災害番号
            emerg_cls: item.emergCls, // 緊急事態区分
            disaster_cls: item.disasterCls, // 災害区分
            delivery_no: item.deliveryNo, // 元の配信番号
            delivery_no_sub: item.deliveryNoSub, // 元の配信番号
            delivery_ca: "LI", // 配信先キャリア（"LI"固定）
            delivery_cls: item.deliveryCls, // 配信区分
            delivery_status: item.deliveryStatus, // 配信状況
            delivery_title: item.deliveryTitle, // 配信タイトル
            lalert_message: item.lalertMessage, //本文／避難行動指針
            related_url: item.relatedUrl ?? "", // 関連URL
            publish_end_date: this.changeDateFormat(item.publishEndDate), // 希望公開終了日時の日付形式変更 (YYYY-MM-DD HH:mm:00)
            correct_cancel_reason: item.correctCancelReason, // 訂正/取消理由
            hash: item.hash // ハッシュ値
          };
          break;
      }
      return retPayload;
    },

    // 日付形式変更 ( yyyy/mm/dd hh:mm:ss -> YYYY-MM-DD HH:mm:ss )
    changeDateFormat(date) {
      return this.$moment(
        date,
        config.DATETIME_FORMAT_YYYYMMDDHHMMSS_WITH_SLASH_COLON
      ).format(config.DATETIME_FORMAT_YYYYMMDDHHMM00_WITH_HYPHEN_COLON);
    },

    //PAZ及びUPZチェック処理
    markPazUpz() {
      this.submitItem.deliveryArea = [];
      this.municipalities.forEach(manicipality => {
        this.systemInfos.forEach(systemInfo => {
          if (manicipality.value === systemInfo.value) {
            this.submitItem.deliveryArea.push(manicipality.value);
          }
        });
      });
    },

    // 配信区分による非活性処理
    // 非活性にするコードをパラメータでもらう(NE:新規、FU：続報、CO：訂正、CA：取消)
    checkDeliveryCls(...deliveryClsStatus) {
      let disabled = false;
      disabled = deliveryClsStatus.includes(this.submitItem.deliveryCls);
      return disabled;
    },

    // 配信先エリアの「全て」チェック処理
    selectAllToggle() {
      this.$nextTick(() => {
        if (this.selectAllMunicip) {
          this.submitItem.deliveryArea = [];
        } else {
          this.submitItem.deliveryArea = [];
          this.municipalities.forEach(manicipality => {
            this.submitItem.deliveryArea.push(manicipality.value);
          });
        }
      });
    }
  }
};
</script>
